export default {
  components: {
  },
  props: ['item', 'index', 'transferType', 'projectType', 'projectSubType'],
  data() {
    return {
    };
  },
  created() {
  },
  computed: {
  },
  methods: {
  }
};
